import { render, staticRenderFns } from "./DialogProjectGroup.vue?vue&type=template&id=24323a02"
import script from "./DialogProjectGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogProjectGroup.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports